import { Type } from '@sinclair/typebox';
import { createChangelogActions, createChangelogOptions, } from '../../../../utils/changelogs/changelogs-utils.js';
import { NullishType } from '../../standard-schema.js';
import { AtaStatusType } from '../../domain/ata/ata.js';
import { FromChangelogSchema, ToChangelogSchema } from './changelogs-schema.js';
const AtaType = 'Ata';
const statusChanged = 'status_changed';
const commentChanged = 'comment_changed';
export const AtaChangelogOptions = createChangelogOptions(AtaType, {
    statusChanged,
    commentChanged,
});
const AtaTypeSchema = Type.Intersect([
    Type.Object({
        auditableType: Type.Literal(AtaChangelogOptions.type),
    }),
]);
// For logs that do not conform with the expected schema
const BackupAtaSchema = Type.Object({
    action: Type.String(),
    changes: Type.Unknown(),
    // Needed to set aside the expected schemas and TS typing
    // without it all the literals are merged into string and changes unknown
    valid: Type.Literal(false),
});
export const AtaStatusChangedSchema = createChangelogActions(AtaChangelogOptions.actions.statusChanged, {
    from: NullishType(Type.Enum(AtaStatusType)),
    to: NullishType(Type.Enum(AtaStatusType)),
});
export const AtaCommentChangedSchema = createChangelogActions(AtaChangelogOptions.actions.commentChanged, {
    from: NullishType(Type.String()),
    to: NullishType(Type.String()),
});
// Saved changelogs that might not conform to the expected schema
export const AtaToChangelogSchema = Type.Intersect([
    ToChangelogSchema,
    AtaTypeSchema,
    Type.Union([AtaStatusChangedSchema.To, AtaCommentChangedSchema.To, BackupAtaSchema]),
]);
// Should only expect changelogs that conform to the expected schema when creating new ones
export const AtaFromChangelogSchema = Type.Intersect([
    FromChangelogSchema,
    AtaTypeSchema,
    Type.Union([AtaStatusChangedSchema.From, AtaCommentChangedSchema.From]),
]);
const StringSafeAtaToChangelogSchema = Type.Intersect([
    Type.Omit(AtaToChangelogSchema, ['timestamp']),
    Type.Object({ timestamp: Type.String() }),
]);
const WithUserAtaToChangelogSchema = Type.Intersect([
    Type.Omit(StringSafeAtaToChangelogSchema, ['userId']),
    Type.Object({
        user: Type.Object({
            id: Type.String(),
            name: Type.String(),
        }),
    }),
]);
export const GetAtaChangelogsResponseSchema = Type.Array(WithUserAtaToChangelogSchema);
